import { ButtonHTMLAttributes, FC } from 'react'
import clsx from 'clsx'

interface Props {
  isLoading: boolean
}

const IconButton: FC<Props & ButtonHTMLAttributes<HTMLButtonElement>> = ({
  isLoading = false,
  children,
  className,
  ...rest
}) => (
  <button
    type="button"
    disabled={isLoading}
    className={clsx(
      'p-2 m-2 text-gray-400 rounded h-min hover:bg-green-500 hover:text-white focus:outline-none',
      className
    )}
    {...rest}
  >
    {children}
  </button>
)

export default IconButton
